module.exports = __webpack_public_path__ + "static/img/posBackground.1325d30.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/technology/posBackground.jpg
// module id = oBSX
// module chunks = 0